import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddServiceRoutingModule } from './add-service-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AddServiceRoutingModule
  ]
})
export class AddServiceModule { }
